import { combineEpics } from "redux-observable";
import { messageListLoadEpicReducer } from "../ducks/messageList.duck.js";
const messageListEpic = combineEpics(messageListLoadEpicReducer.epic);
export {
  messageListEpic
};
//# sourceMappingURL=messageList.epics.js.map
